import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("project-1", "Dome Miner", "img/projects/dome_miner.gif", 
    `
    <div class="paragraph">
     <img src="img/projects/dome_miner_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 10px; border-radius: 30px;">
     Embark on an interstellar mining adventure with Dome Miner! 
     Land your dome on exotic alien planets teeming with resources and hidden dangers. Drill beneath the surface, shatter rocks, 
     and collect valuable minerals to upgrade your gear and enhance your dome. 
     <br/><br/>But watch out—every so often, alien creatures emerge to challenge your presence. 
     Use your dome's powerful laser to defend against relentless attacks from above! Equip yourself wisely as you explore, 
     and balance your time between deep mining and strategic defense to retrieve the Artifacts!
    </div>
    <div class="paragraph center">
        <a href="https://apps.apple.com/us/app/dome-miner/id6737137746" target="_blank"><img src="img/projects/app-store-logo.png" alt="Play Store badge" width="250" /></a>
    </div>
    <div class="paragraph center">
        <img class="phone-screenshot" src="img/projects/dome_miner_s1.png" alt="Dome Miner Screenshot" />
        <img class="phone-screenshot" src="img/projects/dome_miner_s2.png" alt="Dome Miner Screenshot" />
        <img class="phone-screenshot" src="img/projects/dome_miner_s3.png" alt="Dome Miner Screenshot" />
        <img class="phone-screenshot" src="img/projects/dome_miner_s4.png" alt="Dome Miner Screenshot" />
        <img class="phone-screenshot" src="img/projects/dome_miner_s5.png" alt="Dome Miner Screenshot" />
        <img class="phone-screenshot" src="img/projects/dome_miner_s6.png" alt="Dome Miner Screenshot" />
    </div>
    <div class="paragraph">
        Key features:
        <ul>
            <li>Epic Mining Exploration</li>
                <ul>
                    <li>Drill underground to uncover rare resources.</li>
                    <li>Each planet offers unique terrains and secrets.</li>
                    <li>The deeper you go, the richer the rewards—but also the risks!</li>
                </ul>
            <li>Upgrade and Customize</li>
                <ul>
                    <li>Use your resources to boost movement speed, drill power, and more.</li>
                    <li>Tailor your upgrades to match your playstyle.</li>
                </ul>
            <li>Strategic Defense</li>
                <ul>
                    <li>Protect your dome from alien threats with powerful defenses.</li>
                    <li>Install enhancements to strengthen your dome after each mission.</li>
                    <li>Balance your time between mining below and defending above.</li>
                </ul>
            <li>Roguelite Progression</li>
                <ul>
                    <li>Permanent upgrades between runs add depth and replayability.</li>
                    <li>Discover new strategies and equipment combinations on every playthrough.</li>
                </ul>
            <li>Stunning Graphics and Smooth Controls</li>
                <ul>
                    <li>Enjoy vibrant visuals and intuitive gameplay.</li>
                    <li>Immerse yourself in the atmospheric sound effects and music.</li>
                </ul>
        </ul>
    </div>

    <div class="paragraph">
     Are you ready to become the ultimate Dome Miner? Download now and start your cosmic journey!
    </div>
    `, "#1895DD", true),
    new ProjectData("project-2", "Flappy Crush", "img/projects/flappy_crush.gif", `
    <div class="paragraph">
     <img src="img/projects/flappy_crush_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 30px; border-radius: 30px;">
     Tap the screen to close the pipes and crush any birds trying to flap through!
     </br></br>
     Key features:
        <ul>
            <li>Unlock awesome power ups and unleash them on the birds!</li>
            <li>Unlock powerful Pipes with amazing bonuses!</li>
            <li>Earn Bone Bucks every turn you play and spend them in the Shop!</li>
            <li>Customize the birds with lots of hilarious unlockable costumes!</li>
            <li>Unlock 5 different Game Modes!</li>
            <li>Same screen 2 Player Mode!</li>
            <li>Can be played offline! No Wifi or Internet connection required!</li>
            <li>Cloud save means you can pick up where you left off on a new device!</li>

        </ul>
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/GUCJLMvqo5s" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
        <a href="https://apps.apple.com/us/app/flappy-crush/id906357856" target="_blank"><img src="img/projects/app-store-logo.png" alt="Play Store badge" width="250" /></a>
    </div>
    <div class="paragraph center">
        <img class="phone-screenshot" src="img/projects/flappy_crush_s1.png" alt="Flappy Crush Screenshot" />
        <img class="phone-screenshot" src="img/projects/flappy_crush_s2.png" alt="Flappy Crush Screenshot" />
        <img class="phone-screenshot" src="img/projects/flappy_crush_s3.png" alt="Flappy Crush Screenshot" />
        <img class="phone-screenshot" src="img/projects/flappy_crush_s4.png" alt="Flappy Crush Screenshot" />
        <img class="phone-screenshot" src="img/projects/flappy_crush_s5.png" alt="Flappy Crush Screenshot" />
    </div>
    <div class="paragraph">
        
    </div>

    <div class="paragraph">
     WARNING: Not for the faint hearted! Lots of pixel gore inside! (With an option to switch off the blood to make it less gory)
    </div>

    <div class="paragraph">
    <!-- 
    <div class="notice">
        Windows build available on <a href="https://some.where/nice" target="_blank">itch.io</a>.
        Source code is available on <a href="https://github.com/yourself" target="_blank">GitHub</a>.
    </div>
    -->
    </div>
    `, "#24b324"),
    new ProjectData("project-3", "Run of Life", "img/projects/run_of_life.gif", `
    <div class="paragraph">
     <img src="img/projects/run_of_life_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 30px; border-radius: 30px;">
     Experience a lifetime with every run! Collect items that make you younger and avoid the obstacles that make you grow older! 
     </br>Be careful not to get too old or it will be game over, literally!
    </div>
    <div class="paragraph center">
        </br></br></br>
        <iframe class="youtube" src="https://www.youtube.com/embed/nMC_PZXRCwA" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
        <a href="http://apps.apple.com/us/app/run-of-life/id1558155715" target="_blank"><img src="img/projects/app-store-logo.png" alt="Play Store badge" width="250" /></a>
    </div>
    <div class="paragraph center">
        <a href="https://play.google.com/store/apps/details?id=com.tarekmongy.RunofLife" target="_blank"><img src="img/projects/play-store-logo.png" alt="Play Store badge" width="250" /></a>
    </div>
    <div class="paragraph center">
        <img class="phone-screenshot" src="img/projects/runoflife_s1.png" alt="Run of Life Screenshot" />
        <img class="phone-screenshot" src="img/projects/runoflife_s2.png" alt="Run of Life Screenshot" />
        <img class="phone-screenshot" src="img/projects/runoflife_s3.png" alt="Run of Life Screenshot" />
        <img class="phone-screenshot" src="img/projects/runoflife_s4.png" alt="Run of Life Screenshot" />
        <img class="phone-screenshot" src="img/projects/runoflife_s5.png" alt="Run of Life Screenshot" />
        <img class="phone-screenshot" src="img/projects/runoflife_s6.png" alt="Run of Life Screenshot" />
    </div>
    
    </div>
    `, "#b034ff", true),
    new ProjectData("project-4", "Hyperdrive Jump", "img/projects/hyperdrive_jump.gif", `
    <div class="paragraph">
     <img src="img/projects/hyperdrivejump_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 30px; border-radius: 30px;">
     Jump your way through each level by passing different tricky obstacles. Time your jumps right or else you will crash! Simple one tap controls!
    </div>
    <div class="paragraph center">
        <a href="https://apps.apple.com/us/app/hyperdrive-jump/id1471327515" target="_blank"><img src="img/projects/app-store-logo.png" alt="App Store badge" width="250" /></a>
    </div>
    </div>
    `, "#f333ff"),
    new ProjectData("project-5", "Bouncy Race 3D", "img/projects/bouncy_race.gif", `
    <div class="paragraph">
     <img src="img/projects/bouncy_race_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 30px; border-radius: 30px;">
     Bounce your way around the track and beat the other players to reach the finish line first! The most fun race on mobile is here!
     </br>Very easy to play, just slide your finger left and right to move. Avoid the obstacles, aim for the bounce pads and don't fall in the water!
    </div>
    <div class="paragraph center">
        <a href="https://apps.apple.com/us/app/bouncy-race-3d/id1474955085" target="_blank"><img src="img/projects/app-store-logo.png" alt="App Store badge" width="250" /></a>
    </div>
    </div>
    `, "#e48246"),
    new ProjectData("project-6", "Unwrinkle", "img/projects/unwrinkle.gif", `
    <div class="paragraph">
        <img src="img/projects/unwrinkle_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 30px; border-radius: 30px;">
        Unwind after a long day with the most satisfying ironing experience ever! Relax and iron away all the wrinkles in this calming, satisfying and zen game.
        </br>Simple one touch controls: just slide your finger to move the iron and smooth out the wrinkles in the clothing. No timers, no pressure, just straight up stress-relieving fun.
    </div>
    <div class="paragraph center">
        <a href="https://apps.apple.com/us/app/unwrinkle/id1486802593" target="_blank"><img src="img/projects/app-store-logo.png" alt="App Store badge" width="250" /></a>
    </div>
    </div>
    `, "#0dad60"),
    new ProjectData("project-7", "Trigger Time", "img/projects/trigger_time.gif", `
        <div class="paragraph">
            <img src="img/projects/trigger_time_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 30px; border-radius: 30px;">
            Take out the bad guys in style! Unique gameplay where time moves only when you move. Take your time to decide your next move, then execute it perfectly with easy to pickup controls!
        </div>
        <div class="paragraph center">
            <a href="https://apps.apple.com/us/app/trigger-time/id1542448910" target="_blank"><img src="img/projects/app-store-logo.png" alt="App Store badge" width="250" /></a>
        </div>
        </div>
        `, "#ff3f3f"),
    new ProjectData("project-8", "People Run", "img/projects/people_run.gif", `
        <div class="paragraph">
            <img src="img/projects/people_run_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 30px; border-radius: 30px;">
            Get as many people to the finish line as you can! Swipe left and right to move your line and add more people to it. Then sacrifice them to cross the different barriers and pass through!
        </div>
        <div class="paragraph center">
            <a href="https://apps.apple.com/us/app/people-run/id1507403855" target="_blank"><img src="img/projects/app-store-logo.png" alt="App Store badge" width="250" /></a>
        </div>
        </div>
        `, "#3363fe"),
    new ProjectData("project-9", "Build And Destroy!", "img/projects/build_destroy.gif", `
        <div class="paragraph">
            <img src="img/projects/build_destroy_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 30px; border-radius: 30px;">
            Build you tower any way you want, then battle against your opponent to see who will take down the other's building first!
        </div>
        <div class="paragraph center">
            <a href="https://apps.apple.com/us/app/build-and-destroy/id1550441853" target="_blank"><img src="img/projects/app-store-logo.png" alt="App Store badge" width="250" /></a>
        </div>
        </div>
        `, "#9faa2a", true),
    new ProjectData("project-10", "Rolly Plane", "img/projects/rolly_plane.gif", `
        <div class="paragraph">
            <img src="img/projects/rolly_plane_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 30px; border-radius: 30px;">
            Swipe your finger left and right to roll the plane's wings and slide through all the different obstacles! Fly through the sky in style!
        </div>
        <div class="paragraph center">
            <a href="https://apps.apple.com/us/app/rolly-plane/id1526666826" target="_blank"><img src="img/projects/app-store-logo.png" alt="App Store badge" width="250" /></a>
        </div>
        </div>
        `, "#ff9019"),
    new ProjectData("project-11", "Handy Hand", "img/projects/handy_hand.gif", `
        <div class="paragraph">
            <img src="img/projects/handy_hand_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 30px; border-radius: 30px;">
            Control the Hand to protect the character from the obstacles in the path and safely reach the finish line!
        </div>
        <div class="paragraph center">
            <a href="https://play.google.com/store/apps/details?id=com.tarekmongy.HandyHand" target="_blank"><img src="img/projects/play-store-logo.png" alt="Play Store badge" width="250" /></a>
        </div>
        </div>
        `, "#ff4c9c"),
    new ProjectData("project-12", "Square Em All", "img/projects/square_all.gif", `
        <div class="paragraph">
            <img src="img/projects/square_all_icon.png" alt="Game Image" width="180" height="180" align="left" style="margin-right: 30px; border-radius: 30px;">
            Draw squares (or rectangles!) with the same color corners to clear the board and meet the levels objectives!
        </div>
        <div class="paragraph center">
            <a href="https://play.google.com/store/apps/details?id=com.tarekmongy.squareemall" target="_blank"><img src="img/projects/play-store-logo.png" alt="Play Store badge" width="250" /></a>
        </div>
        </div>
        `, "#944cff"),
];